// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as FlightActions } from '../duck';
import Flight from '../components/Flight';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    isFetchingFlight: state.flight.isFetchingFlight,
    flight: state.flight.flight,
    fetchFlightError: state.flight.fetchFlightError,
    localValues: state.localValues,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ ...FlightActions }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Flight);



// WEBPACK FOOTER //
// ./src/modules/flight/containers/FlightContainer.js